$(document).ready(function(){

    const swiper = new Swiper('.swiper-container', {
        scrollbar: {
            el: '.swiper-scrollbar',
            hide: false,
        },

        slidesPerView: 2,
        loop: true,
        freeMode: true,

        autoplay: {
            delay: 2500,
            disableOnInteraction: false,
        },

        breakpoints: {
            750: {
                slidesPerView: 3,
            },
            1199: {
                slidesPerView: 5,
            },
        },
    });

    $(".featured-prd-thumb-item img").click(function(){
        var imgSrc = $(this).attr("src");
        $(this).closest(".featured-prd-thumbs").find(".featured-prd-thumb-item").removeClass("active-f-thumb");
        $(this).parent(".featured-prd-thumb-item").addClass("active-f-thumb");
        var mainImg = $(this).closest(".featured-prd-gallery").find(".product__media.media.media--transparent img");
        mainImg.attr("src", imgSrc);
        mainImg.attr("srcset", null);
    });

    // testimonial slider
    $(".testimonial-review-list").slick({
        dots: false,
        adaptiveHeight: true,
        arrows: true,
        infinite: true,
        nextArrow: '<div class="next_arrow_slick"><svg width="13" height="22" viewBox="0 0 13 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.3521 11.629L1.61655 21.6336C1.43742 21.8006 1.19943 21.8938 0.951955 21.8938C0.704475 21.8938 0.466494 21.8006 0.287365 21.6336L0.275806 21.6223C0.188667 21.5413 0.119282 21.4439 0.071867 21.3359C0.0244522 21.2278 9.53674e-07 21.1115 9.53674e-07 20.994C9.53674e-07 20.8764 0.0244522 20.7601 0.071867 20.6521C0.119282 20.544 0.188667 20.4466 0.275806 20.3656L10.3853 10.9451L0.275806 1.52831C0.188667 1.44735 0.119282 1.34989 0.071867 1.24187C0.0244522 1.13385 9.53674e-07 1.01752 9.53674e-07 0.899963C9.53674e-07 0.782408 0.0244522 0.666082 0.071867 0.55806C0.119282 0.450039 0.188667 0.352581 0.275806 0.271614L0.287365 0.260309C0.466494 0.0932922 0.704475 0.00012207 0.951955 0.00012207C1.19943 0.00012207 1.43742 0.0932922 1.61655 0.260309L12.3521 10.2649C12.4465 10.3529 12.5217 10.4587 12.573 10.576C12.6244 10.6932 12.6509 10.8194 12.6509 10.947C12.6509 11.0745 12.6244 11.2007 12.573 11.318C12.5217 11.4352 12.4465 11.541 12.3521 11.629Z" fill="black"/></svg></div>',
        prevArrow: '<div class="prev_arrow_slick"><svg width="13" height="22" viewBox="0 0 13 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.298778 11.629L11.0343 21.6336C11.2135 21.8006 11.4514 21.8938 11.6989 21.8938C11.9464 21.8938 12.1844 21.8006 12.3635 21.6336L12.3751 21.6223C12.4622 21.5413 12.5316 21.4439 12.579 21.3359C12.6264 21.2278 12.6509 21.1115 12.6509 20.994C12.6509 20.8764 12.6264 20.7601 12.579 20.6521C12.5316 20.544 12.4622 20.4466 12.3751 20.3656L2.26558 10.9451L12.3751 1.52831C12.4622 1.44735 12.5316 1.34989 12.579 1.24187C12.6264 1.13385 12.6509 1.01752 12.6509 0.899963C12.6509 0.782408 12.6264 0.666082 12.579 0.55806C12.5316 0.450039 12.4622 0.352581 12.3751 0.271614L12.3635 0.260309C12.1844 0.0932922 11.9464 0.00012207 11.6989 0.00012207C11.4514 0.00012207 11.2135 0.0932922 11.0343 0.260309L0.298778 10.2649C0.204363 10.3529 0.129198 10.4587 0.0778403 10.576C0.0264823 10.6932 0 10.8194 0 10.947C0 11.0745 0.0264823 11.2007 0.0778403 11.318C0.129198 11.4352 0.204363 11.541 0.298778 11.629Z" fill="black"/></svg></div>',
        speed: 1000,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 2000,
        responsive: [
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 749,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false
                }
            }
        ]
    });

    // blog slider
    $(".custom-articles-list").slick({
        dots: false,
        adaptiveHeight: true,
        arrows: true,
        infinite: true,
        nextArrow: '<div class="next_arrow_slick"><svg width="13" height="22" viewBox="0 0 13 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.3521 11.629L1.61655 21.6336C1.43742 21.8006 1.19943 21.8938 0.951955 21.8938C0.704475 21.8938 0.466494 21.8006 0.287365 21.6336L0.275806 21.6223C0.188667 21.5413 0.119282 21.4439 0.071867 21.3359C0.0244522 21.2278 9.53674e-07 21.1115 9.53674e-07 20.994C9.53674e-07 20.8764 0.0244522 20.7601 0.071867 20.6521C0.119282 20.544 0.188667 20.4466 0.275806 20.3656L10.3853 10.9451L0.275806 1.52831C0.188667 1.44735 0.119282 1.34989 0.071867 1.24187C0.0244522 1.13385 9.53674e-07 1.01752 9.53674e-07 0.899963C9.53674e-07 0.782408 0.0244522 0.666082 0.071867 0.55806C0.119282 0.450039 0.188667 0.352581 0.275806 0.271614L0.287365 0.260309C0.466494 0.0932922 0.704475 0.00012207 0.951955 0.00012207C1.19943 0.00012207 1.43742 0.0932922 1.61655 0.260309L12.3521 10.2649C12.4465 10.3529 12.5217 10.4587 12.573 10.576C12.6244 10.6932 12.6509 10.8194 12.6509 10.947C12.6509 11.0745 12.6244 11.2007 12.573 11.318C12.5217 11.4352 12.4465 11.541 12.3521 11.629Z" fill="black"/></svg></div>',
        prevArrow: '<div class="prev_arrow_slick"><svg width="13" height="22" viewBox="0 0 13 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.298778 11.629L11.0343 21.6336C11.2135 21.8006 11.4514 21.8938 11.6989 21.8938C11.9464 21.8938 12.1844 21.8006 12.3635 21.6336L12.3751 21.6223C12.4622 21.5413 12.5316 21.4439 12.579 21.3359C12.6264 21.2278 12.6509 21.1115 12.6509 20.994C12.6509 20.8764 12.6264 20.7601 12.579 20.6521C12.5316 20.544 12.4622 20.4466 12.3751 20.3656L2.26558 10.9451L12.3751 1.52831C12.4622 1.44735 12.5316 1.34989 12.579 1.24187C12.6264 1.13385 12.6509 1.01752 12.6509 0.899963C12.6509 0.782408 12.6264 0.666082 12.579 0.55806C12.5316 0.450039 12.4622 0.352581 12.3751 0.271614L12.3635 0.260309C12.1844 0.0932922 11.9464 0.00012207 11.6989 0.00012207C11.4514 0.00012207 11.2135 0.0932922 11.0343 0.260309L0.298778 10.2649C0.204363 10.3529 0.129198 10.4587 0.0778403 10.576C0.0264823 10.6932 0 10.8194 0 10.947C0 11.0745 0.0264823 11.2007 0.0778403 11.318C0.129198 11.4352 0.204363 11.541 0.298778 11.629Z" fill="black"/></svg></div>',
        speed: 1000,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 2000,
        responsive: [
            {
                breakpoint: 993,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 749,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false
                }
            }
        ]
    });

    // about page marquee
    $('.marquee-icons-list').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      speed: 5000,
      autoplay: true,
      autoplaySpeed: 0,
      cssEase: 'linear',
      variableWidth: true,
      infinite: true,
      arrows: false,
      dots: false,
      pauseOnHover: true,
      pauseOnFocus: false
    });

    // FAQs
    $('.faqs-list').on('click', '.acc__title', function (e) {
        var accCard = $(this).closest('.acc__card');
        var accContainer = $(this).closest('.faqs-list');
        var accPanel = accCard.find('.acc__panel');
        var accTitle = $(this);
        var plusIcon = accTitle.find('.plus_icon');
        var minusIcon = accTitle.find('.minus_icon');

        if (accCard.hasClass('active_item')) {
            accCard.removeClass('active_item');
            accTitle.removeClass('active');
            accPanel.stop(true, true).slideUp();
            plusIcon.show();
        } else {
            accContainer.find('.acc__card').not(accCard).each(function () {
                $(this).removeClass('active_item')
                .find('.acc__panel').stop(true, true).slideUp().end()
                .find('.acc__title').removeClass('active')
                .find('.plus_icon').show().end();
            });

            accCard.addClass('active_item');
            accTitle.addClass('active');
            accPanel.stop(true, true).slideDown();
        }
    });

    // product page gallery slider
    $(".main-gallery-slick-enabled").slick({    
        dots: false,
        arrows: true,
        prevArrow: '<div class="arrow_prev linear-slick-arrow"><svg width="12" height="22" viewBox="0 0 12 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.7961 1L1 10.7961L10.7961 20.5923" stroke="url(#paint0_linear_116_1419)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><defs><linearGradient id="paint0_linear_116_1419" x1="5.89807" y1="20.5923" x2="5.89807" y2="1" gradientUnits="userSpaceOnUse"><stop stop-color="#1F2E6F"/><stop offset="1" stop-color="#238DC1"/></linearGradient></defs></svg></div>',
        nextArrow: '<div class="arrow_next linear-slick-arrow"><svg width="12" height="22" viewBox="0 0 12 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L10.7961 10.7961L1 20.5923" stroke="url(#paint0_linear_116_1422)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><defs><linearGradient id="paint0_linear_116_1422" x1="5.89807" y1="20.5923" x2="5.89807" y2="1" gradientUnits="userSpaceOnUse"><stop stop-color="#1F2E6F"/><stop offset="1" stop-color="#238DC1"/></linearGradient></defs></svg></div>',
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        asNavFor: '.main-thumbs-slick-enabled',
        slidesToScroll: 1,
        adaptiveHeight: true
    });

    $(".main-thumbs-slick-enabled").slick({
        dots: false,
        asNavFor: '.main-gallery-slick-enabled',
        arrows: false,
        infinite: false,
        slidesToShow: 4,
        verticalSwiping: true,
        vertical: true,
        slidesToScroll: 1,
        adaptiveHeight: true,
        responsive: [
            {
                breakpoint: 993,
                settings: {
                    verticalSwiping: false,
                    vertical: false
                }
            },
            {
                breakpoint: 767,
                settings: {
                    verticalSwiping: false,
                    vertical: false
                }
            }
        ]
    });

    setTimeout(function () {
        $('.main-thumbs-slick-enabled').slick('setPosition');
    }, 200);

    $(".main-gallery-slick-enabled").on('afterChange', function(event, slick, currentSlide){
        var indexslide = currentSlide+1;
        console.log("Current Slide Index:", indexslide);
        $("ul.thumbnail-list li button[aria-current]").removeAttr("aria-current");
        $('ul.thumbnail-list li[data-media-position="' + indexslide + '"] button').attr("aria-current", "true");
    });

    $("ul.thumbnail-list").on("click", "li button", function () {
        var index = $(this).closest("li").data("media-position");
        if (typeof index !== 'undefined') {
            var slideIndex = parseInt(index, 10) - 1;
            $(".main-gallery-slick-enabled").slick("slickGoTo", slideIndex);
        }
    });

    function mobileSlick() {
        if (window.innerWidth <= 767) {

        if (!$('.pdp-features-list').hasClass('slick-initialized')) {
            $('.pdp-features-list').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: true,
                infinite: true,
                adaptiveHeight: false
            });
        }

        } else {
            if ($('.pdp-features-list').hasClass('slick-initialized')) {
                $('.pdp-features-list').slick('unslick');
            }
        }
    }

    mobileSlick();

    $(window).on('resize orientationchange', function () {
        mobileSlick();
    });

});